import { GrCircleInformation } from "react-icons/gr";

const InformationIcon = (props) => {
  return <GrCircleInformation className={props.className} />;
};

export default InformationIcon;
